const model = {
  id: '',
  p_startdts: 0,
  p_finishdts: 0,
  p_duration: 0,
  age: 0,
  judge_before: '',
  judge_after: '',
  judge_whynot: '',
  comments: '',
  can_duration: '',
  can_onset: '',
  can_perception: '',
  one_a_running: '',
  one_b_housing: '',
  one_c_homeless: '',
  one_d_services: '',
  one_e_supervision: '',
  one_f_school: '',
  one_g_cps: '',
  two_a_secabuse: '',
  two_b_physicalabuse: '',
  two_c_emotionalabuse: '',
  two_d_violence: '',
  three_a_appearance: '',
  three_b_phystrauma: '',
  three_c_tattoo: '',
  three_d_pregsti: '',
  three_e_sleep: '',
  three_f_nutrition: '',
  three_g_sud: '',
  three_h_increasesud: '',
  four_a_risksex: '',
  four_b_location: '',
  four_c_language: '',
  four_d_association: '',
  four_e_bullied: '',
  four_f_jj: '',
  four_g_gang: '',
  five_a_unhealthyrel: '',
  five_b_onlinerel: '',
  five_c_photos: '',
  five_d_money: '',
  five_e_manyphones: '',
  five_f_travel: '',
  six_a_hypervigilant: '',
  six_b_cues: '',
  six_c_risktaking: '',
  six_d_celldistress: '',
  seven_a_abusive: '',
  seven_b_isolation: '',
  seven_c_pregnant: '',
  seven_d_coercion: '',
  seven_e_threats: '',
  seven_f_vague: '',
  eight_a_exploited: '',
  eight_b_filmed: '',
  eight_c_history: '',
  eight_d_quota: '',
  calc_q1: '',
  calc_q2: '',
  calc_q3: '',
  calc_q4: '',
  calc_q5: '',
  calc_q6: '',
  calc_q7: '',
  calc_q8: '',
  calc_cseitScore: '',
  createdBy: '',
  updatedBy: '',
  person: '',
  organizationCreator: '',
  organizationOwner: ''
}

export { model }



// WEBPACK FOOTER //
// ./src/api/models/cseit.js